import { authenticated } from './WebRequest';
import { omitNil } from 'js/mylib/Utils';
import type {
  ApiThunk,
  PosStatisticsResponse,
  PurgeStatisticsParameters,
  PurgeStatisticsResponse,
  StatisticsSiteParameters,
} from './types/Statistics';

export type {
  ApiThunk,
  PosStatisticsResponse,
  PurgeStatisticsParameters,
  PurgeStatisticsResponse,
  PurgeStatisticsRow,
  StatisticsColorantRow,
  StatisticsColourRow,
  StatisticsProductRow,
  StatisticsSiteParameters,
  StatisticsWeekdayRow,
  StatisticsYearWeekRow,
  StatisticsZone,
} from './types/Statistics';

export function pos_stats(
  parameters: StatisticsSiteParameters
): ApiThunk<PosStatisticsResponse> {
  const { siteid, ...params } = omitNil(parameters);
  return authenticated.get(`/statistics/site/${siteid}/pos_stats`, { params });
}

export function purge(
  parameters: PurgeStatisticsParameters
): ApiThunk<PurgeStatisticsResponse> {
  const { siteid, ...params } = omitNil(parameters);
  return authenticated.get(`/statistics/site/${siteid}/purge_detail/`, {
    params,
  });
}
